"use client";

import { useEffect, useState } from "react";
import { FiShoppingBag } from "react-icons/fi";
import { IoIosHeart, IoMdHeartEmpty } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  deleteWishlist,
  postWishlist,
} from "../../redux/features/WishlistSlice";

const SingleProduct = ({ product }) => {
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);

  const wishLists = useSelector((state) => state.wishlist.wishlist);

  const alreadyWished = wishLists?.some(
    (item) => item?.product?.id === product?.id
  );

  const toggleHeart = () => {
    toast.dismiss();
    if (alreadyWished) {
      dispatch(
        deleteWishlist({
          id: wishLists?.find((data) => data?.product?.id === product?.id)?.id,
        })
      );
    } else {
      dispatch(
        postWishlist({
          data: { product: product?.id },
          params: {
            populate: "product",
          },
        })
      );
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Calculate minimum selling price and price from variations or use product's prices
  const [minSellingPrice, setMinSellingPrice] = useState(0);
  const [minPrice, setMinPrice] = useState(0);

  // if the product has variations, then select the minimum with the lowest price,
  // else use products selling price and price

  useEffect(() => {
    if (product?.variations?.length > 0) {
      const minVariation = product?.variations?.reduce((min, current) => {
        return current.selling_price < min.selling_price ? current : min;
      });
      setMinSellingPrice(minVariation?.selling_price);
      setMinPrice(minVariation?.price);
    } else {
      setMinSellingPrice(product?.selling_price || 0);
      setMinPrice(product?.price || 0);
    }
  }, [product]);

  return (
    <div className="flex flex-col w-full overflow-hidden bg-white border group">
      {/* Product Image Container */}
      <Link
        className="relative block overflow-hidden aspect-square"
        to={`/product/${product?.slug}`}
        // onClick={scrollToTop}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Primary Image */}
        <img
          className={`absolute inset-0 w-full object-cover transition-opacity duration-500 aspect-[3/4] ${
            isHovered ? "opacity-0" : "opacity-100"
          }`}
          src={product?.gallery?.[0]?.url || "/placeholder.svg"}
          alt={product?.name || "Product image"}
        />

        {/* Secondary Image (Visible on Hover) */}
        <img
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
            isHovered ? "opacity-100" : "opacity-0"
          }`}
          src={
            product?.gallery?.[1]?.url ||
            product?.gallery?.[0]?.url ||
            "/placeholder.svg"
          }
          alt={product?.name || "Product image hover"}
        />

        {/* Wishlist and Cart Buttons */}

        {/* Wishlist Button */}
        <button
          onClick={(e) => {
            e.preventDefault();
            toggleHeart();
          }}
          className="absolute top-0 right-0 flex items-center justify-center w-10 h-10 text-white transition bg-gray-900 hover:bg-gray-700"
        >
          {alreadyWished ? (
            <IoIosHeart className="w-5 h-5 text-red-500" />
          ) : (
            <IoMdHeartEmpty className="w-5 h-5" />
          )}
        </button>
        <div className="absolute bottom-0 right-0 space-y-2 transition-all duration-300 opacity-0 group-hover:opacity-100 group-hover:right-0">
          {/* Cart Button */}
          <button className="flex items-center justify-center w-10 h-10 text-white transition bg-gray-900 cursor-pointer hover:bg-gray-700">
            <FiShoppingBag className="w-5 h-5" />
          </button>
        </div>
      </Link>

      {/* Product Details */}
      <div className="p-4 border-t">
        <Link to={`/product/${product?.slug}`} onClick={scrollToTop}>
          <h5 className="text-sm font-medium text-gray-700 truncate hover:text-gray-900">
            {product?.name}
          </h5>
        </Link>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-baseline gap-1.5">
            <span className="text-sm font-semibold text-gray-900">
              Rs. {minSellingPrice}
            </span>

            {minPrice !== minSellingPrice && (
              <span className="text-xs text-gray-400 line-through">
                Rs. {minPrice}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleProduct;
